<template>
  <input
      :type="type"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @keypress="$emit('keypress', $event)">
</template>

<script>
export default {
  name: 'BaseInput',
  props: {
    type: String,
    value: String,
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

input {
  background: $input-background;
  border-radius: 0.25rem;
  border: none;
  color: $text;
  font-size: 1rem;
  line-height: 1.25rem;
  outline: none;
  padding: 0.5rem;

  &:disabled {
    background: $input-background-disabled;
    color: $disabled-text;
  }

  &:not(:disabled) {
    &:focus {
      background: $input-background-focus;
    }
  }
}
</style>
